module.exports = __webpack_public_path__ + "img/icon_fb.2593ed71.svg";